var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg6Package(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h260v260H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.103 233.237-2.841.145c-7.358.352-27.24 1.26-37.59.966-12.817-.377-56.948-.966-76.07-1.353-19.124-.387-55.78-.628-78.503-.55-17.224.057-43.537-.668-55.17-1.015-1.02 0-1.933-.049-2.677-.092h-.537A145.974 145.974 0 0 1 0 231.227s.251-6.17.45-13.398c.067-2.29.15-4.696.173-7.04.111-3.985.174-7.773.14-10.585-.058-9.707.667-43.445 1.145-54.224.479-10.78 1.45-40.101 1.228-51.697-.208-8.726.16-30.37.348-40.42.062-3.247.125-5.276.125-5.276l2.947.034 252.808 3.174c.292 1.451.454 2.926.483 4.406.102 3.754.03 9.277-.183 15.46v.04c0 .483-.025.918-.044 1.4l-.111 2.86-.188 4.388c-.034.937 0 1.899-.073 2.899-.13 3.29-.28 6.619-.386 9.9a578.6 578.6 0 0 0-.445 12.513c0 1.164-.048 2.353-.043 3.556l-.271 17.645c-.043 3.556-.097 7.18-.14 10.735a3.638 3.638 0 0 0 0 .56 788.448 788.448 0 0 1-.17 8.586c-.125 6.991-.299 13.398-.598 18.394a57.001 57.001 0 0 0-.15 2.203c-.058 1.097-.16 2.416-.198 3.918-.13 2.261-.213 4.962-.266 7.948-.517 20.471-.478 54.03-.478 54.03Z",
    fill: "#E5E4E4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.49 64.226 115.926 215.1c-2.538 6.535-9.89 9.779-16.427 7.247l-1.56-.623a12.712 12.712 0 0 1-7.272-16.46l12.402-31.932 19.365-49.958 17.876-45.952 8.9-22.988 25.278 9.793Z",
    fill: "#CBE8EE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.34.355 28.775 11.166a.98.98 0 0 1 .56 1.268l-22.9 59.007a.98.98 0 0 1-1.268.559l-28.774-11.167a.98.98 0 0 1-.56-1.268l22.9-59.006a.98.98 0 0 1 1.268-.56Z",
    fill: "#343F69",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.455 2.852 1.758.69a.3.3 0 0 1 .17.389l-22.18 56.479a.3.3 0 0 1-.389.17l-1.758-.69a.3.3 0 0 1-.17-.39l22.18-56.479a.3.3 0 0 1 .39-.17Z",
    fill: "#272E4E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#272E4E",
    fillRule: "nonzero",
    transform: "rotate(21.695 162.795 33.831)",
    x: 161.55,
    y: 3.165,
    width: 2.49,
    height: 61.333,
    rx: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.093 5.459 1.758.69a.3.3 0 0 1 .17.389l-22.18 56.479a.3.3 0 0 1-.389.17l-1.757-.69a.3.3 0 0 1-.17-.39l22.18-56.479a.3.3 0 0 1 .388-.17ZM180.644 6.849l1.758.69a.3.3 0 0 1 .17.39l-22.18 56.478a.3.3 0 0 1-.39.17l-1.757-.69a.3.3 0 0 1-.17-.39l22.18-56.478a.3.3 0 0 1 .389-.17ZM183.974 8.159l1.758.69a.3.3 0 0 1 .17.389l-22.18 56.479a.3.3 0 0 1-.389.17l-1.758-.69a.3.3 0 0 1-.17-.39l22.18-56.479a.3.3 0 0 1 .39-.17ZM187.3 9.469l1.757.69a.3.3 0 0 1 .17.389l-22.18 56.479a.3.3 0 0 1-.389.17l-1.757-.691a.3.3 0 0 1-.17-.389l22.18-56.479a.3.3 0 0 1 .388-.17ZM190.636 10.77l1.757.691a.3.3 0 0 1 .17.389l-22.18 56.479a.3.3 0 0 1-.388.17l-1.758-.69a.3.3 0 0 1-.17-.39l22.18-56.479a.3.3 0 0 1 .389-.17ZM194.045 12.118l1.757.69a.3.3 0 0 1 .17.389l-22.18 56.479a.3.3 0 0 1-.388.17l-1.758-.69a.3.3 0 0 1-.17-.39l22.18-56.478a.3.3 0 0 1 .389-.17Z",
    fill: "#272E4E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.95 87.876-16.252 41.86-19.326 49.92-16.297-6.335 19.365-49.957 17.876-45.953 12.079 4.668a4.488 4.488 0 0 1 2.556 5.797Z",
    fill: "#F9B446",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272E4E",
    fillRule: "nonzero",
    d: "m138.698 129.736-19.351 49.919-16.296-6.334 19.364-49.957z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#272E4E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    d: "m150.752 87.915-18.475 46.692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.364 51.8-114.27 15.204-141.5-18.408.17-4.565.227-6.06.15-3.333 255.851 3.208v2.595c-.082 2.005-.198 4.469-.328 6.57-.15 2.658-.3 4.789-.3 4.789Z",
    fill: "#F0F0F0",
    fillRule: "nonzero",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.364 51.8-114.27 15.204-141.5-18.408.17-4.565c12.397.043 74.149.386 91 1.063 18.81.773 72.082.995 86.857 1.106 14.774.111 58.17 1.88 68.97 1.203 3.091-.174 6.203-.3 9.053-.391-.13 2.657-.28 4.788-.28 4.788Z",
    fill: "#E5E4E4",
    fillRule: "nonzero",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#B8B8B9",
    fillRule: "nonzero",
    transform: "rotate(-1.26 134.68 43.535)",
    cx: 134.68,
    cy: 43.535,
    rx: 7.339,
    ry: 2.942
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.65 132.732s62.06 5.957 79.15 5.798c17.089-.16 41.125.13 46.16-.435 5.034-.565 26.037.072 26.037.072l-1.339-11.252-8.696-8.315-74.526-9.562-42.715 1.856-17.21 8.15-6.86 13.688Z",
    fill: "#DFDFDE",
    fillRule: "nonzero",
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.438 123.185s-24.225-5.532-35.579-6.977c-11.354-1.444-28.989-3.604-28.21-1.527.777 2.078 16.325 5.972 27.486 9.799 11.16 3.826 31.515 8.252 31.515 8.252l4.788-9.547Z",
    fill: "#DFDFDE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.354 109.207c-6.358-.265-35.323-1.4-51.537-3.12-18.215-1.957-37.478.405-51.828-2.3-14.35-2.706-67.302-6.765-88.72-8.576C44.85 93.399 9.28 93.447 9.28 93.447l.087 9.9s32.284-1.242 52.113 5.653c19.828 6.894 63.833 10.967 75.526 13.77 11.692 2.802 62.896 2.922 77.878 3.662 13.007.59 37.072.483 43.194.415l.275-17.64ZM257.17 165.122c-5.865.483-24.273 2.136-37.748 2.633-16.248.59-47.237 4.349-67.09 4.073-19.853-.275-68.124 3.064-79.169 2.184-11.045-.88-42.87-3.619-52.803-3.952-9.934-.333-12.113-1.024-12.113-1.024l-.44-9.92s30.12.358 46.112.199c15.993-.16 50.02-1.933 62.182-2.445 12.16-.512 64.495-3.532 75.067-4.083 10.57-.55 37.052-5.314 48.696-5.276 8.735 0 15.21-.512 17.9-.768-.13 6.987-.299 13.398-.593 18.38Z",
    fill: "#EBEBEC",
    fillRule: "nonzero",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.438 180.066a16.379 16.379 0 0 1-7.73-8.136 14.89 14.89 0 0 1 .275-12.625l.048-.097-3.382-1.97a4.276 4.276 0 0 1-4.464.352c-.22-.12-.432-.25-.638-.391h-.038l-3.75 1.932a14.862 14.862 0 0 1-.386 12.35c-.15.29-.324.594-.483.879-2.856 4.865-8.175 7.513-13.731 7.349 5.314 1.25 13.494 1.178 19.987-7.567l.208-.265.193.246c1.295 1.628 8.953 10.784 18.041 9.412a16.427 16.427 0 0 1-4.15-1.469Zm-14.852-30.472-.425-3.546a16.364 16.364 0 0 1-4.832-1.547 16.108 16.108 0 0 1-8.479-10.445 14.693 14.693 0 0 1-.28-6.281 15.987 15.987 0 0 0-1.831 6.107c-.339 3.015.11 6.619 1.85 10.822 0 0-9.697-.454-14.886 6.967a15.944 15.944 0 0 1 16.23-.966 16.379 16.379 0 0 1 6.28 5.576c.039.024.049.053.078.091l.207-.12 3.349-1.696a4.406 4.406 0 0 1 2.73-4.953l.009-.01Zm31.825 4.59c-2.604-4.247-7.112-8.393-14.939-8.518a24.027 24.027 0 0 0 2.831-8.822c.406-3.938-.294-8.552-4.097-12.562l-.106-.126c.027.038.046.08.058.126a15.011 15.011 0 0 1 .913 12.296c-.18.496-.394.98-.638 1.45a14.978 14.978 0 0 1-13.151 8.155l.42 3.416c.137.03.27.08.392.15a4.348 4.348 0 0 1 2.304 4.928l1.45.826 1.889 1.068c.36-.443.75-.86 1.164-1.252 4.59-4.46 11.895-5.648 18.181-2.498.787.394 1.543.846 2.261 1.353.735.54 1.427 1.135 2.073 1.778a20.606 20.606 0 0 0-1.005-1.778v.01Z",
    fill: "#272E4E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.455 142.226c4.102-3.15 8.851-3.213 13.784-.74.731.323 1.415.742 2.034 1.247M129.745 166.398c-5.585-2.803-8.571-8.112-7.605-13.973",
    stroke: "#272E4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.223 90.147 74.26 185.255a7.412 7.412 0 0 0 6.126 11.219l109.458 3.44a7.416 7.416 0 0 0 6.764-10.895l-52.494-98.563a7.412 7.412 0 0 0-12.89-.309Z",
    stroke: "#272E4E",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8 211.418c-.483 1.57-2.469 2.048-4.136 2.174-11.537 1.111-23.19.406-34.786.043-5.798-.183-11.596-.285-17.37-.053a30.81 30.81 0 0 0-3.27.445c.067-2.29.15-4.697.169-7.05 3.865.372 8.059 1.194 9.803 1.228a174.63 174.63 0 0 0 31.139-2.334c5.831-.923 12.562-1.84 16.963 2.058 1.01.84 1.88 2.208 1.488 3.489Z",
    fill: "#DFDFDE",
    fillRule: "nonzero",
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.586 179.201c-2.967.483-8.252 1.194-13.074.966-7.247-.314-17.393-.115-17.393-.115 0-1.634-3.015-8.77-3.015-8.77 3.585-.521 13.117-.193 19.495.682 4.773.628 11.359-.276 14.277-.74-.179 2.276-.261 5.001-.29 7.977Z",
    fill: "#F0F0F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.837 93.138c-1.232.222-3.174.57-6.184.966-7.305.966-18.553 1.034-29.124-3.942-10.571-4.977-16.224-7.146-16.654-7.368 0 0 5.353-.604 10.146.232 4.793.835 19.756.608 28.274.995 4.66.18 9.328-.083 13.939-.788-.13 3.3-.28 6.634-.397 9.905Z",
    fill: "#EEE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.664 71.667v.034c-2.851-.387-9.92-.764-20.336 2.507-13.833 4.348-12.89 6.764-12.6 6.91.29.144 10.513-1.146 19.88-1.29a89.242 89.242 0 0 1 12.722.526l.334-8.687Z",
    fill: "#F4F4F4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.953 116.005-.092 7.402s26.873-.212 31.859-.125c0 0 .328-4.668 3.628-7.248 0 0-12.63-.091-19.466-.101-6.837-.01-15.93.072-15.93.072Z",
    fill: "#F0F0F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.928 231.425c-1.02 0-1.932-.049-2.676-.092.082-2.261.265-6.822.405-11.895.054-1.667.102-3.382.145-5.073 0-.657.039-1.305.049-1.962.082-3.976.16-7.783.12-10.595-.077-9.716.648-43.45 1.131-54.234.483-10.784 1.45-40.101 1.222-51.697-.212-9.247.213-32.917.401-42.034.054-2.3.073-3.662.073-3.662l2.947.034c.213 1.135.362 2.358.483 3.624.619 6.681.039 14.494-.425 18.383-.343 2.788-.483 8.997-.512 13.973v.227a.647.647 0 0 0 0 .193c-.034 3.832 0 6.827 0 6.827l.087 9.89-.87 5.74c-.256 1.73-.415 4.15-.546 6.904v.483c-.222 6.281-.145 14.258-.063 19.911.116 8.315-.072 22.766-.072 22.766l.435 9.924S7.223 181.2 6.89 190.125c-.174 3.952-.387 13.325-.585 22.563a439.278 439.278 0 0 1-.135 6.373c-.087 4.875-.179 9.31-.242 12.364Z",
    fill: "#E3E3E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.818 72.232s12.561 0 23.514.198 17.225 2.585 24.907 2.121c7.682-.464 10.489-1.401 12.103.899 1.613 2.3 2.193 9.209 4.667 11.074 0 0-4.764-.691-15.398-.28-10.634.41-32.221-1.107-37.169-1-4.947.106-13.146 1.371-13.146 1.371l.522-14.383Z",
    fill: "#EBEAEB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.842 56.206c-27.399-.188-141.297-.966-155.955-1.812-14.659-.845-83.266-.59-100.408-.526.067-3.252.116-5.272.116-5.272l2.952.034 252.817 3.17c.29 1.451.45 2.926.478 4.406Z",
    fill: "#DDDDDC",
    fillRule: "nonzero",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E8E7E7",
    fillRule: "nonzero",
    transform: "rotate(-89.12 134.489 43.551)",
    cx: 134.489,
    cy: 43.551,
    rx: 2.353,
    ry: 5.865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.968 40.44c-12.306-.076-50.837-.362-63.413-.854-15.031-.643-54.843-1.488-67.322-1.45-12.48.039-61.51-1.145-74.743-.966-11.63.179-43.228.686-50.504.807l.15-3.334 255.851 3.208c.02.686.02 1.566-.019 2.59Z",
    fill: "#D2161A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.969 167.441c5.59-2.802 8.57-8.117 7.604-13.977",
    stroke: "#272E4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6Package);
export default __webpack_public_path__ + "static/media/6-package.d7bc0d52.svg";
export { ForwardRef as ReactComponent };